/** True when this document is running inside a frame rather than as the top-level page. */
export function isAppRunningInIframe(): boolean {
  return window.self !== window.top;
}
